import { AccountMovement } from "../types/accountMovement"; 
import { createApiStore } from "./genericStore";
import api from "../service/api";
import { toast } from "react-toastify";

const useBaseAccountMovementStore = createApiStore<AccountMovement>("/accountMovement");

export const useAccountMovementStore = () => {
  const store = useBaseAccountMovementStore();

  return {
    ...store,
    sendToGib: async (movementId: number) => {
      try {
        const res = await api.post(`/e-invoice/${movementId}/send`);
        await store.fetchDataDynamic(); // Listeyi yenile
        return res.data;
      } catch (err: any) {
        throw err;
      }
    },
    getInvoicePdf: async (uuid: string, type: string = 'OUTBOUND') => {
      try {
        const res = await api.get(`/e-invoice/${uuid}/pdf`, {
          params: { type },
          responseType: 'arraybuffer'
        });
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } catch (err: any) {
        toast.error("PDF indirilirken hata oluştu.");
        throw err;
      }
    },
    getInvoiceHtml: async (uuid: string, type: string = 'OUTBOUND', direction: string = 'OUT') => {
      try {
        const res = await api.get(`/e-invoice/${uuid}/html`, {
          params: { type, direction }
        });
        return res.data; // Backend'den saf HTML dönmeli
      } catch (err: any) {
        throw err;
      }
    }
  };
};
